import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Captcha from "../captcha/captcha";
import { getQuickRegisterForm, getCart } from "../../services/selectors";
import { useSelector, useDispatch } from "react-redux";
import {
  EDIT_FIRST_NAME_QUICK_REGISTER, EDIT_LAST_NAME_QUICK_REGISTER,
  EDIT_SURNAME_QUICK_REGISTER,
  EDIT_EMAIL_QUICK_REGISTER, SWITCH_CHECKBOX_PERMISSION_QUICK, postRegisterThunk,
  EDIT_PHONE_QUICK_REGISTER
} from "../../services/actions/quick_register_form_actions";
import { checkInput, generateCode } from "../../utils/util_functions";

const QuickRegisterForm = () => {


  const [formValid, setFormValid] = useState(false);
  const [statusFirstName, setStatusFirstName] = useState({ valid: false });
  const [statusLastName, setStatusLastName] = useState({ valid: false });
  const [statusSurname, setStatusSurname] = useState({ valid: false });
  const [statusEmail, setStatusEmail] = useState({ valid: false });
  const [statusPhone, setStatusPhone] = useState({ valid: false });
  const [code, setCode] = useState();
  const [validCaptcha, setValidCaptcha] = useState(true);

  const captchaRef = useRef(null);

  const dispatch = useDispatch();

  const cart = useSelector(getCart);

  const navigate = useNavigate();

  const {
    first_name, last_name, surname, email, phone, checkbox_permission
  } = useSelector(getQuickRegisterForm);


  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(postRegisterThunk(first_name, last_name, surname, email, phone, navigate, cart.productsInCart));
  };

  useEffect(() => {
    setFormValid(
      statusFirstName?.valid && statusLastName?.valid &&
      statusSurname?.valid && statusEmail?.valid && statusPhone?.valid &&
      checkbox_permission && validCaptcha
    );
    // eslint-disable-next-line
  }, [first_name, last_name, surname, email, phone, checkbox_permission, validCaptcha]);


  const changeFirstName = (e) => {
    if (e.target.value.length > 34) {
      e.target.value = e.target.value.slice(0, 34);
    }
    const currStatus = checkInput(e.target.value, 2, 34, 'string');
    setStatusFirstName({ ...statusFirstName, valid: currStatus.valid, text: currStatus.text });
    dispatch({ type: EDIT_FIRST_NAME_QUICK_REGISTER, first_name: e.target.value });
  }
  const changeLastName = (e) => {
    if (e.target.value.length > 34) {
      e.target.value = e.target.value.slice(0, 34);
    }
    const currStatus = checkInput(e.target.value, 2, 34, 'string');
    setStatusLastName({ ...statusLastName, valid: currStatus.valid, text: currStatus.text });
    dispatch({ type: EDIT_LAST_NAME_QUICK_REGISTER, last_name: e.target.value });
  }
  const changeSurname = (e) => {
    if (e.target.value.length > 34) {
      e.target.value = e.target.value.slice(0, 34);
    }
    const currStatus = checkInput(e.target.value, 2, 34, 'string');
    setStatusSurname({ ...statusSurname, valid: currStatus.valid, text: currStatus.text });
    dispatch({ type: EDIT_SURNAME_QUICK_REGISTER, surname: e.target.value });
  }
  const changeEmail = (e) => {
    if (e.target.value.length > 64) {
      e.target.value = e.target.value.slice(0, 64);
    }
    const currStatus = checkInput(e.target.value, 8, 64, 'email');
    setStatusEmail({ ...statusEmail, valid: currStatus.valid, text: currStatus.text });
    dispatch({ type: EDIT_EMAIL_QUICK_REGISTER, email: e.target.value });
  }
  const changePhone = (e) => {
    if (e.target.value.length > 12) {
      e.target.value = e.target.value.slice(0, 12);
    }
    const currStatus = checkInput(e.target.value, 11, 12, 'tel');
    setStatusPhone({ ...statusPhone, valid: currStatus.valid, text: currStatus.text });
    dispatch({ type: EDIT_PHONE_QUICK_REGISTER, phone: e.target.value });
  }
  const changeCheckPermission = (e) => {
    dispatch({
      type: SWITCH_CHECKBOX_PERMISSION_QUICK,
      checkbox_permission: e.target.checked
    });
  }

  return (
    <form onSubmit={handleSubmit} className="form" noValidate>
      <label htmlFor="last_name" className="label_text">
        Фамилия <span style={{ color: 'red' }}>*</span>
        <input
          type="text"
          id="last_name" name="last_name"
          required={true}
          value={last_name}
          onChange={changeLastName}
          className="input"
        />
        <p className="error">{statusLastName?.text}</p>
      </label>
      <label htmlFor="first_name" className="label_text">
        Имя <span style={{ color: 'red' }}>*</span>
        <input
          type="text"
          id="first_name" name="first_name"
          required={true}
          value={first_name}
          onChange={changeFirstName}
          className="input"
        />
        <p className="error">{statusFirstName?.text}</p>
      </label>
      <label htmlFor="surname" className="label_text">
        Отчество <span style={{ color: 'red' }}>*</span>
        <input
          type="text"
          id="surname" name="surname"
          required={true}
          value={surname}
          onChange={changeSurname}
          className="input"
        />
        <p className="error">{statusSurname?.text}</p>
      </label>
      <label htmlFor="email" className="label_text">
        Email <span style={{ color: 'red' }}>*</span>
        <input
          type="email"
          id="email" name="email"
          required={true}
          value={email}
          onChange={changeEmail}
          className="input"
        />
        <p className="error">{statusEmail?.text}</p>
      </label>
      <label htmlFor="phone_profile" className="label_text">
        Телефон <span style={{ color: 'red' }}>*</span>
        <input
          type="tel"
          id="phone_profile" name="phone_profile"
          value={phone}
          onChange={changePhone}
          className="input"
        />
        <p className="error">{statusPhone?.text}</p>
      </label>
      <label htmlFor="check_permission" className="label_text">
        <input
          type="checkbox"
          id="check_permission" name="check_permission"
          className="checkbox"
          onChange={changeCheckPermission}
        />
        &emsp; Я даю согласие на хранение и обработку предоставленных
        персональных данных в соответствии с
        <Link to='/agreement' style={{ color: 'inherit' }}> Условиями</Link>
        &nbsp;<span style={{ color: 'red' }}>*</span>
      </label>
      <label htmlFor="captcha" className="label_text">
        Защита от ботов <span style={{ color: 'red' }}>*</span>
        <Captcha
          generateCode={() => generateCode(setCode)}
          setValidCaptcha={setValidCaptcha}
          code={code}
          ref={captchaRef}
        />
        {!validCaptcha && <p className="error error_captcha">Неправильный код.</p>}
      </label>
      <button type="submit"
        className={`button ${!formValid ? 'button_disabled' : ''}`}
        disabled={!formValid}
      >
        Сохранить данные
      </button>
    </form>
  );
};

export default QuickRegisterForm;
